import { useCallback, useMemo, useState } from 'react';
import { SwitchStatus } from '../';
import { UpdateLasHourRateEndDateModal } from '../';
import { useGetCurrentUser } from '@/modules/Users/queries';

type UserStatusSwitchProps = {
  userId: number;
  status: boolean;
  onChange: (checked: boolean) => void;
};

export const UserStatusSwitch = ({
  userId,
  status,
  onChange,
}: UserStatusSwitchProps) => {
  const [isOpenEndDateModal, setIsOpenEndDateModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(false);

  const handleEndDateModalState = useCallback(() => {
    setIsOpenEndDateModal((prevIsOpen) => !prevIsOpen);
  }, []);

  const { data: currentUser } = useGetCurrentUser();

  const isOwnUser = useMemo(
    () => userId === currentUser?.id,
    [userId, currentUser?.id],
  );

  const handleStatusChange = useCallback(
    (checked: boolean) => {
      if (checked) {
        onChange(checked);
        return;
      }

      setSelectedStatus(checked);
      setIsOpenEndDateModal(true);
    },
    [onChange],
  );

  const handleAfterEndDateSubmit = useCallback(() => {
    setIsOpenEndDateModal(false);
    onChange(selectedStatus);
  }, [onChange, selectedStatus]);

  return (
    <div>
      <SwitchStatus
        disabled={isOwnUser}
        onChange={handleStatusChange}
        checked={status}
      />
      {isOpenEndDateModal && (
        <UpdateLasHourRateEndDateModal
          userId={userId}
          isOpen={isOpenEndDateModal}
          handleClose={handleEndDateModalState}
          handleAfterSubmit={handleAfterEndDateSubmit}
        />
      )}
    </div>
  );
};
